import React from "react";
import { ChallengeTableInspectionsProgramsVersionsItem } from "../../../api/types/dtos/challenge/ChallengeDto";

export type CellStateValue = Partial<
  Omit<
    ChallengeTableInspectionsProgramsVersionsItem,
    "id" | "programVersionId" | "inspectionProgramId"
  >
> & { _error?: boolean };

export type CellState = Record<string, CellStateValue>;

export interface ChallengeCellContextValue {
  cellState: CellState;
  updating: Record<string, boolean>;
  handleCellStateChange: (
    cellKeyFromParam: string,
    itemId: string,
    nextState: Partial<
      Pick<
        ChallengeTableInspectionsProgramsVersionsItem,
        "isActive" | "isApproved" | "comments" | "value"
      >
    >,
  ) => void;
  handleOpenCellModal: (
    modalItem: ChallengeTableInspectionsProgramsVersionsItem,
    key: string,
    formTemplateJson?: string,
  ) => void;
}

export const ChallengeCellContext =
  React.createContext<ChallengeCellContextValue | null>(null);
